import React, { forwardRef, useImperativeHandle, useState } from 'react'
import ClickablePopup from './ClickablePopup'
import type { ClickablePopupOpenArgs, ClickablePopupProps } from './types'

export type ClickablePopupHostHandle = {
	open: (popup: ClickablePopupOpenArgs) => void
}

// Owns "is a popup open?" so opening/closing it does not re-render the page
// (and its DataGrid). The grid only calls host.open(...).
export const ClickablePopupHost = forwardRef<
	ClickablePopupHostHandle,
	Pick<ClickablePopupProps, 'model' | 'folder' | 'onChanged'>
>((props, ref) => {
	const [popup, setPopup] = useState<ClickablePopupOpenArgs | null>(null)
	useImperativeHandle(ref, () => ({ open: setPopup }), [])

	return popup ? <ClickablePopup {...props} {...popup} onHide={() => setPopup(null)} /> : null
})

ClickablePopupHost.displayName = 'ClickablePopupHost'
